<template>
  <div class="animated fadeIn">
    <b-col lg="15">
      <c-table caption="PlanItem"></c-table>
    </b-col>
  </div>
</template>

<script>
import cTable from './PlanItem.vue'
export default {
  name: 'tables',
  components: {cTable}
}
</script>



// WEBPACK FOOTER //
// src/views/home/Plan.vue